<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">
      {{ $t("payment schedules") }}
    </div>

    <payment-schedule-datatable ref="payment_schedule_datatable" />
  </section>
</template>

<script>
import PaymentScheduleDatatable from "./payment_schedule_datatable/Index.vue";

export default {
  name: "PaymentSchedule",
  components: {
    PaymentScheduleDatatable,
  },
};
</script>
